/** Dashed placeholder for a project tab with nothing to show: "No <label> extracted…", or a custom `message`. */
export function TabEmptyState(props: { label: string } | { message: string }) {
  return (
    <div className="flex min-h-[160px] items-center justify-center rounded-lg border border-dashed border-gray-200 px-6 py-8 text-sm text-gray-500 dark:border-zinc-700 dark:text-zinc-400">
      {'message' in props ? props.message : `No ${props.label} extracted for this project`}
    </div>
  );
}
